import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-space-between fill-height" }
const _hoisted_2 = {
  key: 0,
  class: "text-primary text-h5 font-weight-bold"
}
const _hoisted_3 = {
  key: 1,
  class: "text-primary text-h5 font-weight-bold"
}
const _hoisted_4 = {
  key: 2,
  class: "text-primary text-h5 font-weight-bold"
}
const _hoisted_5 = {
  key: 0,
  class: "text-primary text-body-1"
}
const _hoisted_6 = {
  key: 1,
  class: "text-primary text-body-1"
}
const _hoisted_7 = {
  key: 2,
  class: "text-primary text-body-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_LoginError = _resolveComponent("LoginError")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ActionButton = _resolveComponent("ActionButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_sheet, {
      color: "transparent",
      height: "48"
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_ctx.error)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "12",
              style: {"min-height":"68px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LoginError, { error: _ctx.error }, null, 8, ["error"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      style: _normalizeStyle(_ctx.error ? 'height: calc(100% - 48px - 68px)' : 'height: calc(100% - 48px)')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.resent=false; _ctx.error=''; _ctx.goToEmail();}),
                      icon: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { color: "primary" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-arrow-left")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { class: "text-center" }, {
                  default: _withCtx(() => [
                    (!_ctx.resent && !_ctx.activating)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Reset password"))
                      : (_ctx.resent && !_ctx.activating)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Password reset"))
                        : _createCommentVNode("", true),
                    (_ctx.activating)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Resend registration email"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      width: "36",
                      height: "36",
                      color: "transparent"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.resent && !_ctx.activating)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "If you've lost or want to reset your password, please confirm."))
                      : _createCommentVNode("", true),
                    (!_ctx.resent && _ctx.activating)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Click the button below to request a new registration code."))
                      : _createCommentVNode("", true),
                    (_ctx.resent)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "An email has been sent. " + _toDisplayString(!_ctx.activating ? 'Please follow the instructions to reset your password.' : ''), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          class: "d-flex justify-center my-6"
        }, {
          default: _withCtx(() => [
            (!_ctx.resent && !_ctx.activating)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 0,
                  onClick: _ctx.resetPassword,
                  text: "Reset password",
                  color: "primary",
                  loading: _ctx.loading
                }, null, 8, ["onClick", "loading"]))
              : _createCommentVNode("", true),
            (!_ctx.resent && _ctx.activating)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 1,
                  onClick: _ctx.resendActivationCode,
                  text: "Resend registration email",
                  color: "primary",
                  loading: _ctx.loading
                }, null, 8, ["onClick", "loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style"])
  ]))
}